import { gql } from "@apollo/client";

import IOperation from "api/IOperation";
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { UpdateOrderCustomerMutation as UpdateOrderCustomerMutationType, UpdateOrderCustomerMutationVariables } from "gql/types/mutations/UpdateOrderCustomerMutation";

const text = gql`mutation UpdateOrderCustomerMutation($updateOrderCustomerInput: MutationUpdateOrderCustomerInput!) {
	updateOrderCustomer(updateOrderCustomerInput: $updateOrderCustomerInput) {
		order {
			id
		}
	}
}
`;

const UpdateOrderCustomerMutation: IOperation<UpdateOrderCustomerMutationType, UpdateOrderCustomerMutationVariables> = { text } as any;

export default UpdateOrderCustomerMutation;
